export const getSecretHeader = () => {
  return {
    'x-tg-token': 'tg-70925739',
  }
}
